export default "__VITE_ASSET__BQjD4kPF__"